import script from "./SfxEntityReference.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxEntityReference.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QSpace,QIcon});qInstall(script, 'directives', {Ripple});
